export default {
  setEquipmentPlaces(state, value) {
    state.equipmentPlaces = value
  },
}
